import { observable, configure, action } from 'mobx';
import LocalModel from './localModel';
import util from 'preact-util';

configure({ enforceActions: 'always' });

class ExamStore extends LocalModel {
    constructor() {
        super('exam', {
            namePlural: 'exams',
            namePluralReal: 'exams',
            sort: '-createdDate',
            limit: 100,
            api: {
                search: { url: '/api/exams/', params: { limit: 100, sort: '-createdDate' } },
                load: { url: '/api/exams/', params: {} },
                save: { url: '/api/exams/', params: {} },
                delete: { url: '/api/exams/', params: {} },
            },
        });
    }

    @observable total = 0;
    @observable limit = 100;
    @observable offset = 0;
    @observable newExam = {};
    @observable exam = {};
    @observable exams = [];

    /** id → title for the courses that invited users to the current exam. */
    @observable courseTitles = {};

    @action
    async loadCourseTitles(courseIds = []) {
        const ids = [...new Set((courseIds || []).map(id => parseInt(id, 10)).filter(id => id > 0))];
        if (ids.length === 0) {
            this.updateKeyValue('courseTitles', {});
            return null;
        }
        const response = await util.fetchApi('/api/courses/', { method: 'GET' }, { id: ids, limit: ids.length });
        if (response?.status === 200) {
            const titles = {};
            (response.data || []).forEach(c => { titles[c.id] = c.title; });
            this.updateKeyValue('courseTitles', titles);
        }
        return response;
    }

    /** Re-send the invitation e-mail and push to one invited user. */
    @action
    async remindInvitedUser(examId, userId) {
        return util.fetchApi(`/api/exams/${examId}/remind`, { method: 'POST' }, { user: userId });
    }

    @action
    async loadExam(id) {
        const response = await util.fetchApi(`/api/exams/${id}`, { method: 'GET' }, {});
        if (response?.status === 200 && response.data?.length > 0) {
            this.updateKeyValue('exam', response.data[0]);
        }
        return response;
    }

    @action
    async inviteUser(examId, userObj) {
        const response = await util.fetchApi(`/api/exams/${examId}`, { method: 'PATCH' }, {
            invitedUsers: {
                id: userObj.id,
                firstname: userObj.firstname,
                lastname: userObj.lastname,
                email: userObj.email,
            },
        });
        if (response?.status === 202) {
            await this.loadExam(examId);
        }
        return response;
    }

    @action
    async removeInvitedUser(examId, currentInvitedUsers, userId) {
        const updatedUsers = currentInvitedUsers.filter(u => (u.id || u) !== userId);
        const response = await util.fetchApi(`/api/exams/${examId}`, { method: 'PATCH' }, {
            'invitedUsers-overwrite': updatedUsers,
        });
        if (response?.status === 202) {
            await this.loadExam(examId);
        }
        return response;
    }
}

const store = new ExamStore();
export default store;
